import { trace } from "owa-trace";
import { orchestrator } from "satcheljs";
import initializePreviewSchedulePageStates from "../actions/initializePreviewSchedulePageStates";
import { IPreviewSchedulePageStore } from "../store/PreviewSchedulePageStore";
import { isoUTCStringToMoment, updatePreviewScheduleViewDimensionsCore } from "./updatePreviewScheduleViewDimensionsOrchestrator";
import { defaultScheduleCalendarType } from "../../schedules/lib/constants/ScheduleDefaults";

export const initializePreviewSchedulePageStatesOrchestrator = orchestrator(
    initializePreviewSchedulePageStates,
    async (actionMessage: {viewState: IPreviewSchedulePageStore}) => {
        trace.info("Initializing Preview Schedule Page States");
        const { viewState } = actionMessage;
        if (!viewState) {
            return;
        }

        try {
            await populateViewState(viewState);
            trace.info("Preview Schedule Page States initialized successfully");
        } catch (error) {
            trace.error("initializePreviewSchedulePageStatesOrchestrator: Failed to populate preview schedule view state", error);
        }
    }
);

const populateViewState = async (store: IPreviewSchedulePageStore) => {
    const scheduleCalendarType = defaultScheduleCalendarType;
    const selectedDate = isoUTCStringToMoment(store.startDate);

    // Call the core function directly and await it to ensure data is loaded before continuing
    await updatePreviewScheduleViewDimensionsCore(
        store,
        selectedDate,
        scheduleCalendarType,
        true /* isTeamBootstrap */
    );
};
